import { useMemo } from 'react';
import { useAuthContext } from '@/context/AuthContext';
import { hasAllPermissions } from '@/utils/accountPermissions';

/**
 * Effective permission bitmask for the logged-in account (from merged roles).
 */
export function useEffectivePermissions() {
    const { user } = useAuthContext();
    return user?.permissions ?? 0;
}

/**
 * Whether the current user has all listed permission flags (bitwise AND, same as API checks).
 * @param {...(import('@/constants/permissions').PERMISSIONS[keyof typeof import('@/constants/permissions').PERMISSIONS]|string|number)} keys
 */
export function useHasPermissions(...keys) {
    const mask = useEffectivePermissions();
    return useMemo(() => hasAllPermissions(mask, ...keys), [mask, keys]);
}
